<div class="period-container">
  <div class="flex flex-row justify-center items-center">
    <div class="period">
      <div class="program-dropdown-wrapper">
        <div class="program-box">
          <div
            class="program {{ programCss }}"
            [class.dhw]="scheduleService.isDhwSchedule$ | async"
          ></div>
        </div>
        <mat-form-field class="program-dropdown" mat-select-height-medium data-at-program>
          <mat-label>{{ '+SCHEDULES.LABEL.MODE' | translate }}</mat-label>
          <mat-select
            data-at-program-select
            fieldTextContentTooltip
            class="program-select"
            [ngModel]="period.mode"
            (ngModelChange)="onProgramChange($event)"
          >
            <mat-option
              data-at-option
              *ngFor="let program of programs"
              attr.option="option-{{ program.value }}"
              [value]="program.value"
              gtm="onSelect"
              gtmAction="Program"
              gtmCategory="editSchedule"
              fieldTextContentTooltip
            >
              <div class="flex flex-row gap-[18px] justify-start items-center w-full">
                <div
                  class="program select-program {{ program.css }} min-w-[50px] max-w-[50px]"
                  [class.dhw]="scheduleService.isDhwSchedule$ | async"
                ></div>
                <div [attr.data-at-selected-program]="program.value" class="grow w-full">
                  {{ program.value | translateOperatingProgram }}
                </div>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="time-dropdown-wrapper" mat-select-height-medium>
        <mat-form-field data-at-start class="time-select">
          <mat-label>HH:MM</mat-label>
          <mat-select
            data-at-start-select
            fieldTextContentTooltip
            class="start-time-select"
            [ngModel]="period.start"
            (ngModelChange)="onStartTimeChange($event)"
          >
            <mat-option
              data-at-option
              *ngFor="let time of getTimes('00:00', period.end, period.end)"
              [attr.data-at-option-time]="time"
              attr.option="option-{{ time }}"
              [value]="time"
              gtm="onSelect"
              gtmAction="Program start time"
              gtmCategory="editSchedule"
              fieldTextContentTooltip
            >
              {{ time }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="time-separator">-</div>
        <div>
          <mat-form-field mat-select-height-medium data-at-end class="time-select">
            <mat-label>HH:MM</mat-label>
            <mat-select
              data-at-end-select
              fieldTextContentTooltip
              class="end-time-select"
              [ngModel]="period.end"
              (ngModelChange)="onEndTimeChange($event)"
            >
              <mat-option
                data-at-option
                *ngFor="let time of getTimes(period.start, '24:00', period.start)"
                [attr.data-at-option-time]="time"
                attr.option="option-{{ time }}"
                [value]="time"
                gtm="onSelect"
                gtmAction="Program end time"
                gtmCategory="editSchedule"
                fieldTextContentTooltip
              >
                {{ time }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
